export default __webpack_public_path__ + "static/media/personal-care.63ba6cda.jpg";